import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pageUrl", "pageContext", "form", "messageField"]

  connect() {
    this.populateContext()
  }

  populateContext() {
    // Always capture current URL
    if (this.hasPageUrlTarget) {
      this.pageUrlTarget.value = window.location.href
    }

    // Extract context from page data attributes
    const context = this.extractPageContext()
    if (this.hasPageContextTarget) {
      this.pageContextTarget.value = JSON.stringify(context)
    }
  }

  submit(event) {
    // Re-populate before submit in case user navigated via Turbo
    this.populateContext()
  }

  extractPageContext() {
    const context = {}

    // Try process show page
    const processEl = document.querySelector("[data-command-palette-process-reference-value]")
    if (processEl) {
      context.reference = processEl.dataset.commandPaletteProcessReferenceValue || ""
      context.title = processEl.dataset.commandPaletteProcessTitleValue || ""
      const agentEl = processEl.querySelector("[data-process-show-current-process-value]")
      if (processEl.dataset.processShowCurrentProcessValue) {
        context.reference = processEl.dataset.processShowCurrentProcessValue
      }
    }

    // Try task show page
    const taskEl = document.querySelector("[data-task-show-current-task-value]")
    if (taskEl) {
      context.task_reference = taskEl.dataset.taskShowCurrentTaskValue || ""
    }

    // Try to get agent name from sidebar active item
    const activeAgent = document.querySelector(".menu-item.active, [aria-current='page']")
    if (activeAgent) {
      const agentText = activeAgent.textContent?.trim()
      if (agentText) context.agent_name = agentText
    }

    // Remove empty values
    Object.keys(context).forEach(key => {
      if (!context[key]) delete context[key]
    })

    return context
  }
}
